/**
 * LoadingIndicator Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import Loader from 'react-loaders';

interface IOwnProps {
  className?: string;
}

const classes = new BEM('loading-indicator');

const LoadingIndicator = ({ className }: IOwnProps) => {
  const extraClasses = classNames(
    className,
  );
  return (
    <div {...classes('', '', extraClasses)}>
      <Loader active type="ball-pulse" />
    </div>
  );
};

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/feedback/LoadingIndicator/index.tsx